import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { PublicLanguage } from '../../models/public-language';

@Injectable({ providedIn: 'root' })
export class PublicLanguagesService {
    constructor(private httpClient: HttpClient) {}

    getAll(): Observable<PublicLanguage[]> {
        return this.httpClient
            .get<{ languages: PublicLanguage[] }>(`${environment.api}/languages`)
            .pipe(map(response => response.languages));
    }

    getAllByUuid(uuid: string): Observable<PublicLanguage[]> {
        const params = new HttpParams().set('uuid', uuid);
        return this.httpClient
            .get<{ languages: PublicLanguage[] }>(`${environment.api}/public/languages`, { params })
            .pipe(map(response => response.languages));
    }

    get(params: HttpParams = new HttpParams()): Observable<{ languages: PublicLanguage[] }> {
        return this.httpClient
            .get<{ languages: PublicLanguage[] }>(`${environment.api}/languages`, { params })
            .pipe(take(1));
    }
}
